import { render, staticRenderFns } from "./DistanceStats.vue?vue&type=template&id=046905c8"
import script from "./DistanceStats.vue?vue&type=script&lang=js"
export * from "./DistanceStats.vue?vue&type=script&lang=js"
import style0 from "./DistanceStats.vue?vue&type=style&index=0&id=046905c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports